module.exports = __webpack_public_path__ + "kosare.b1927e0d3198593bf714.jpg";